import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { BusRouteTypeModifyComponent } from "./bus-route-type-modify/bus-route-type-modify.component";
import { DataService_BusTrackerRouteType } from "./shared/data.service";

@Component({
	selector: "app-bus-route-type-maintenance",
	templateUrl: "./bus-route-type-maintenance.component.html",
	styleUrls: ["./bus-route-type-maintenance.component.css"],
})
export class BusRouteTypeMaintenanceComponent implements OnInit {
	constructor(
		private userService: UserService,
		private RouteTypeService: DataService_BusTrackerRouteType,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		// this.loadImportPref();
		this.loadRouteType();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	Processing: any = false;

	ToggleText: any = "Deactivate Route Type";

	ImportLoading: any = false;
	Imported: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedRouteType: any;
	lstRouteType: any = [];

	//Filter lists
	lstActiveDesc: any = [];
	lstDefinedByDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "BusRouteTypeNbr", header: "Code" },
		// { field: 'BusRouteTypeDesc', header: 'Description' },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadImportPref() {
		this.ImportLoading = true;

		var result = this.RouteTypeService.ImportPreferenceSelect();
		result.subscribe(
			(response) => {
				this.Imported = response;

				this.ImportLoading = false;

				this.loadRouteType();
			},
			(error) => {
				this.ImportLoading = true;
			}
		);
	}

	loadRouteType() {
		this.errorMessage = "";

		this.loading = true;

		var result = this.RouteTypeService.RouteTypeSelectAll();
		result.subscribe(
			(response) => {
				this.lstRouteType = response;

				//Load Data Filter Lists
				this.lstActiveDesc = Array.from(new Set(this.lstRouteType.map((item: any) => item.ActiveDesc))).sort();
				this.lstDefinedByDesc = Array.from(new Set(this.lstRouteType.map((item: any) => item.DefinedByDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = true;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadRouteType();
	}

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(BusRouteTypeModifyComponent, {
			header: "Add Route type",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				EditMode: false,
				Imported: false,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadRouteType();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.SelectedRouteType == undefined) {
			this.errorMessage = "Select a route type to edit";
			return;
		}

		var ref = this.dialogService.open(BusRouteTypeModifyComponent, {
			header: "Edit Route Type",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				EditMode: true,
				Imported: this.SelectedRouteType.DefinedByID <= 2 ? true : false,
				BusRouteTypeID: this.SelectedRouteType.BusRouteTypeID,
				BusRouteTypeNbr: this.SelectedRouteType.BusRouteTypeNbr,
				BusRouteTypeDesc: this.SelectedRouteType.BusRouteTypeDesc,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadRouteType();
			}
		});
	}

	onToggle() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedRouteType == undefined) {
			this.errorMessage = "Select a route type to toggle";
			return;
		}

		//Call SP
		this.Processing = true;

		var changeTo = this.SelectedRouteType.Active == true ? 0 : 1;

		var result = this.RouteTypeService.RouteTypeToggle(this.SelectedRouteType.BusRouteTypeID, changeTo);
		result.subscribe(
			(response) => {
				if (response) {
					this.onRowUnselect(null);
					this.loadRouteType();
				} else {
					var MSG = "";

					if (changeTo == 1) {
						MSG = "Could not activate the route type";
					} else {
						MSG = "Could not deactivate the route type";
					}

					//
					// Error message
					//
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: MSG,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onDelete() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedRouteType == undefined) {
			this.errorMessage = "Select a route type to delete";
			return;
		}

		//
		// Check if the Route type is in use
		//
		this.RouteTypeInUse();
	}

	RouteTypeInUse() {
		this.Processing = true;

		var result = this.RouteTypeService.RouteTypeInUse(this.SelectedRouteType.BusRouteTypeID);
		result.subscribe(
			(response) => {
				if (response) {
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Route Type already in use. Delete Bus Routes before deleting this Route type.",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				} else {
					this.ConfirmDelete();
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	ConfirmDelete() {
		this.confirmationService.confirm({
			key: "confirmdelete",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Are you sure you want to delete this Route type?",
			header: "Confirm Delete Route Type",
			icon: "fa",
			accept: () => {
				this.FinishDelete();
			},
			reject: () => {
				this.Processing = false;
			},
		});
	}

	FinishDelete() {
		var result = this.RouteTypeService.RouteTypeDelete(this.SelectedRouteType.BusRouteTypeID);
		result.subscribe(
			(response) => {
				if (response) {
					this.onRowUnselect(null);
					this.loadRouteType();
				} else {
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not delete the Route Type.",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedRouteType = val.data;

		this.ToggleText = "Deactivate Route Type";
		if (this.SelectedRouteType.Active == false) {
			this.ToggleText = "Activate Route Type";
		}
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedRouteType = null;

		this.ToggleText = "Deactivate Route Type";
	}
	onRowDblClick(RouteType) {
		this.errorMessage = "";

		this.SelectedRouteType = RouteType;

		this.ToggleText = "Deactivate Route Type";
		if (this.SelectedRouteType.Active == false) {
			this.ToggleText = "Activate Route Type";
		}

		this.onEdit();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.Processing == true || this.ImportLoading == true;
	}

	CanEdit() {
		return this.SelectedRouteType == undefined ? false : true;
	}

	CanDelete() {
		if (this.SelectedRouteType == undefined) {
			return false;
		}
		if (this.SelectedRouteType.DefinedByID <= 2) {
			return false;
		}

		return true;
	}

	////////////////////////////////////////////
}
